import React from 'react';
import { PipelineMetrics } from '../types/pipeline';
import { TrendingUp, Users, DollarSign, Clock, PieChart } from 'lucide-react';
interface MetricsOverviewProps {
  metrics: PipelineMetrics;
}
export function MetricsOverview({
  metrics
}: MetricsOverviewProps) {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      maximumFractionDigits: 1
    }).format(amount);
  };
  const cards = [{
    label: 'Total Pipeline Value',
    value: formatCurrency(metrics.totalValue),
    icon: DollarSign,
    color: 'text-blue-600',
    bg: 'bg-blue-50',
    trend: '+12% vs last month'
  }, {
    label: 'Active Deals',
    value: metrics.totalDeals.toString(),
    icon: Users,
    color: 'text-indigo-600',
    bg: 'bg-indigo-50',
    trend: '+5 new this week'
  }, {
    label: 'Avg Deal Size',
    value: formatCurrency(metrics.avgDealSize),
    icon: PieChart,
    color: 'text-emerald-600',
    bg: 'bg-emerald-50',
    trend: 'Stable'
  }, {
    label: 'Avg Days to Close',
    value: `${Math.round(metrics.avgDaysInPipeline)} days`,
    icon: Clock,
    color: 'text-amber-600',
    bg: 'bg-amber-50',
    trend: '-2 days improvement'
  }, {
    label: 'Conversion Rate',
    value: `${metrics.conversionRate}%`,
    icon: TrendingUp,
    color: 'text-purple-600',
    bg: 'bg-purple-50',
    trend: 'Top 10% of industry'
  }];
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-8" data-id="element-187">
      {cards.map((card, index) => <div key={card.label} className="bg-white p-5 rounded-lg border border-slate-200 shadow-sm hover:shadow-md transition-all duration-200" data-id="element-188">
          <div className="flex justify-between items-start mb-3" data-id="element-189">
            <div className={`p-2.5 rounded-lg ${card.bg}`} data-id="element-190">
              <card.icon className={`w-5 h-5 ${card.color}`} data-id="element-191" />
            </div>
            {index === 0 && <span className="flex h-2 w-2 relative" data-id="element-192">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-193"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-194"></span>
              </span>}
          </div>
          <div data-id="element-195">
            <p className="text-xs font-medium text-slate-500 mb-1.5 uppercase tracking-wide" data-id="element-196">
              {card.label}
            </p>
            <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-197">
              {card.value}
            </h3>
            <p className="text-xs text-slate-400 font-medium" data-id="element-198">{card.trend}</p>
          </div>
        </div>)}
    </div>;
}